var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RegisterPageTemplate',{attrs:{"titles":_vm.pageTitles,"data":_vm.fullList,"columns":_vm.columnsCards,"sort-columns-by-key":"measurement","order-by-desc":"","side-action-component":"SoilForm","get-data-func":_vm.getData}})
}
var staticRenderFns = []

export { render, staticRenderFns }